import firebase from 'firebase'
import 'firebase/firestore'
// import * as firebase from "firebase"

const firebaseConfig = {
    apiKey: "AIzaSyCeSOzv0snhpq9i5GJ046F9-7dKxO2XRDY",
    authDomain: "vertihub-7cfc1.firebaseapp.com",
    projectId: "vertihub-7cfc1",
    storageBucket: "vertihub-7cfc1.firebasestorage.app",
    messagingSenderId: "717543934360",
    appId: "1:717543934360:web:44b9719410e6c30c3503ed"
}

export const firebaseApp = firebase.initializeApp(firebaseConfig)

firebaseApp.getCurrentUser = () => {
    return new Promise((resolve, reject) => {
        const unsubscribe = firebaseApp.auth().onAuthStateChanged(user => {
            unsubscribe()
            resolve(user)
        }, reject)
    })
}

export const auth = firebase.auth()

auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL)

export const db = firebaseApp.firestore()

const { Timestamp, GeoPoint } = firebase.firestore
export { Timestamp, GeoPoint }
db.settings({ timestampsInSnapshots: true })
